import {
    FETCH_TICKET_DATA,
  } from "../type";
  
  export function ticketData(details:any) {
    return {
      type: FETCH_TICKET_DATA,
      payload: details,
    };
  }
  